import { render, staticRenderFns } from "./app-shop-basket-icon.vue?vue&type=template&id=111af154&"
import script from "./app-shop-basket-icon.vue?vue&type=script&lang=js&"
export * from "./app-shop-basket-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports